import Select from 'react-select'
import { useState } from 'react'
import { get } from '../../utils/Api'
import { useGlobalContext } from '../../utils/Context'
import { useEffect } from 'react'

function NewAutoComplete({ country, handeledData }: any) {
  const { notify } = useGlobalContext()
  const [options, setOptions] = useState([])
  const [selectedData, setSelectedData] = useState({
    label: 'Start typing to search for an address',
    value: '',
  })
  const [loading, setLoading] = useState(false)
  const fetchCity = async (inputValue: string) => {
    if (!inputValue || inputValue.length < 2) return []
    setLoading(true)
    get(`utils/address-autocomplete?address=${inputValue}&country=${country}`)
      .then((result: any) => {
        if (result.status === 200) {
          setOptions(
            result.data.suggests.map((item: any) => ({
              label: item.address,
              value: item.placeId,
              mainText: item?.mainText,
            }))
          )
          setLoading(false)
        } else {
          notify('error', result.message)
        }
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    setOptions([])
    setSelectedData({
      label: 'Start typing to search for an address',
      value: '',
    })
    setLoading(false)
  }, [country])
  const handleSelectChange = (selectedOption: any) => {
    get(
      `utils/place-detail-query?mainText=${selectedOption?.mainText}e&placeId=${selectedOption.value}`
    )
      .then((result: any) => {
        if (result.status === 200) {
          handeledData(result.data)
          setLoading(false)
        } else {
          notify('error', result.message)
        }
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
  }
  return (
    <div className='input-card'>
      <p>
        Search for an address{' '}
        <span style={{ color: '#888', fontSize: '0.9em' }}>
          (optional, autocomplete)
        </span>
      </p>
      <Select
        className='dif'
        classNamePrefix='react-select'
        options={options}
        value={selectedData}
        onChange={(selectedOption: any) => {
          setSelectedData(selectedOption)
          handleSelectChange(selectedOption)
        }}
        isLoading={loading}
        onInputChange={(newValue) => {
          fetchCity(newValue)
        }}
        placeholder='Start typing to search for an address...'
        noOptionsMessage={() => 'No address found'}
        isDisabled={!country}
      />
    </div>
  )
}

export default NewAutoComplete
